import React from 'react'

import { Icon, Icons } from '@clientbase/clientbase-library'
import { Box } from '@mui/material'

import { theme } from 'styles/theme'

interface IconContainerProps {
  icon: Icons | JSX.Element
  color?: string
  size?: number
}

const IconContainer = ({
  icon,
  color = theme.palette.neutral[200],
  size
}: IconContainerProps) => {
  return (
    <Box
      sx={{
        padding: '10px',
        background: '#F8F8F8',
        borderRadius: '8px',

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      {typeof icon === 'object' ? (
        React.cloneElement(icon, { color: color })
      ) : (
        <Icon icon={icon} colorSX={color} size={size || 3} />
      )}
    </Box>
  )
}

export default IconContainer
